module.exports = __webpack_public_path__ + "img/Kr-plugin2.cc5713a0.png";